import { render, staticRenderFns } from "./BusinessCompanyFiles.vue?vue&type=template&id=0a2e014c"
import script from "./BusinessCompanyFiles.vue?vue&type=script&lang=js"
export * from "./BusinessCompanyFiles.vue?vue&type=script&lang=js"
import style0 from "./BusinessCompanyFiles.vue?vue&type=style&index=0&id=0a2e014c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports